// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawerTitle--ztx31","V2VideoPlayer":"V2VideoPlayer--cMXO_","V2VideoPlayerYoung":"V2VideoPlayerYoung--TCtwT","markerAnimationScale":"markerAnimationScale--GOnMz"};